import i18n from 'i18next';

export function safeTranslate(key) {
  if (i18n.exists(key)) {
    return true;
  }
  return false;
}
